import styled from 'styled-components';

export const Container = styled.div`
  padding: 1.5rem;
`;

export const Content = styled.div`
  .chakra-avatar {
    background-color: ${({ theme }) => theme.colors.light.color} !important;
  }

  p {
    text-transform: capitalize;
  }
`;

export const BoxInfo = styled.div`
  padding: 0.875rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  margin-top: 0.75rem;

  h6 {
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 0.25rem;
    color: ${({ theme }) => theme.colors.darkBlue.color};
    text-transform: uppercase;
  }

  p {
    font-size: 0.875rem;
    margin-bottom: 0;
  }
`;
